import React, { Component } from 'react'
import './App.css'
import { Container } from 'reactstrap'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import NavBar from './components/NavBar.js'
import EntriesContainer from './containers/EntriesContainer.js'
import MeasurementsContainer from './containers/MeasurementsContainer'
import LoginContainer from './containers/LoginContainer'
import TagContainer from './containers/TagContainer'

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <NavBar />
          <Container>
            <Route exact path="/tag/:tag" component={TagContainer} />
            <Route exact path="/measurements" component={MeasurementsContainer} />
            <Route exact path="/login" component={LoginContainer} />
            <Route exact path="/" component={EntriesContainer} />
          </Container>
        </div>
      </Router>
    );
  }
}

export default App;
